// extracted by mini-css-extract-plugin
module.exports = {"productsGrid":"_2Irj0","isMobile":"_3QSkz"};